import React, { useState } from "react";
import { LANGUAGES } from "../../../utils/sectionTypes";
import FieldInputRenderer from "./FieldInputRenderer";

const DynamicFieldsEditor = ({ fields, onSaveField, busyFieldId }) => {
  const [language, setLanguage] = useState("en");
  const [drafts, setDrafts] = useState(() => {
    const map = {};
    fields.forEach((field) => {
      map[field.id] = { ...field.translations };
    });
    return map;
  });

  const langMeta = LANGUAGES.find((l) => l.code === language) || LANGUAGES[0];

  const setValue = (fieldId, value) => {
    setDrafts((prev) => ({
      ...prev,
      [fieldId]: {
        ...(prev[fieldId] || {}),
        [language]: value,
      },
    }));
  };

  return (
    <div className="space-y-5">
      <div className="flex flex-wrap gap-2">
        {LANGUAGES.map((lang) => (
          <button
            key={lang.code}
            type="button"
            onClick={() => setLanguage(lang.code)}
            className={[
              "rounded-full px-3 py-1.5 text-xs font-semibold transition",
              language === lang.code
                ? "bg-slate-900 text-white"
                : "bg-slate-100 text-slate-600 hover:bg-slate-200",
            ].join(" ")}
          >
            {lang.label}
          </button>
        ))}
      </div>

      {fields.map((field) => (
        <div key={field.id} className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
          <div className="mb-3 flex items-center justify-between gap-3">
            <div>
              <p className="text-sm font-semibold text-slate-900">{field.label}</p>
              <p className="text-xs text-slate-500">
                key: {field.key} · type: {field.fieldType}
              </p>
            </div>
            <button
              type="button"
              disabled={busyFieldId === field.id}
              onClick={() =>
                onSaveField(field, {
                  ...field.translations,
                  ...(drafts[field.id] || {}),
                })
              }
              className="rounded-xl bg-slate-900 px-3 py-1.5 text-xs font-semibold text-white disabled:opacity-60"
            >
              {busyFieldId === field.id ? "Saving…" : "Save"}
            </button>
          </div>
          <div dir={langMeta.dir}>
            <FieldInputRenderer
              field={field}
              language={language}
              value={drafts[field.id]?.[language] ?? ""}
              onChange={(value) => setValue(field.id, value)}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default DynamicFieldsEditor;
